import { Card } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

export default function ImovelCardSkeleton() {
  return (
    <div className="h-full animate-in fade-in-0 slide-in-from-bottom-5 duration-500 ease-out">
      <Card className="overflow-hidden rounded-xl shadow border bg-white flex flex-col h-full">
        {/* Skeleton da imagem */}
        <div className="relative aspect-[4/3] w-full">
          <Skeleton className="w-full h-full" />
          {/* Skeleton do badge */}
          <div className="absolute top-3 right-3 z-20">
            <Skeleton className="w-16 h-6 rounded-full" />
          </div>
          {/* Skeleton do título e localização */}
          <div className="absolute bottom-0 left-0 w-full p-4 z-10">
            <Skeleton className="h-6 w-3/4 mb-2" />
            <Skeleton className="h-4 w-1/2" />
          </div>
        </div>

        <div className="p-4 flex flex-col flex-1">
          {/* Skeleton do código */}
          <div className="flex justify-end mb-1">
            <Skeleton className="w-20 h-3" />
          </div>

          {/* Skeleton do preço */}
          <Skeleton className="h-8 w-32 mb-1" />

          {/* Skeleton das características */}
          <div className="flex items-center gap-3 mb-1">
            <Skeleton className="h-5 w-8" />
            <Skeleton className="h-5 w-8" />
            <Skeleton className="h-5 w-8" />
            <Skeleton className="h-5 w-12" />
          </div>

          {/* Skeleton do nome do prédio */}
          <Skeleton className="h-3 w-24 mb-1" />

          {/* Skeleton da descrição */}
          <div className="space-y-1 mb-1">
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-3/4" />
          </div>

          <div className="flex-1" />

          {/* Skeleton do botão */}
          <div className="flex justify-center mt-4">
            <Skeleton className="h-10 w-full max-w-xs rounded-lg" />
          </div>
        </div>
      </Card>
    </div>
  );
}
